export default class RapportsActivitesController {
	static $inject = [
		'$scope',
		'$state',
		'$uibModal',
		'RapportsActivitesService',
		'PaginationService',
		'notification',
		'$translate',
		'moment',
		'ModalService'
	];

	constructor($scope, $state, $uibModal, RapportsActivitesService, PaginationService, notification, $translate, moment, ModalService) {
		Object.assign(this, {
			$scope,
			$state,
			$uibModal,
			RapportsActivitesService,
			PaginationService,
			notification,
			$translate,
			moment,
			ModalService,
			loading: false,
			unregister: [],
			formatRapportActivites: [],
			selectedRow: null
		});
	}

	async $onInit() {
		await this.loadNiveauxHierarchique();
		this.prepareNiveauxForSelect();
		await this.initRapportActivites();
	}

	async loadNiveauxHierarchique() {
		this.startLoading();
		try {
			this.niveauxHierarchique = await this.RapportsActivitesService.getProduitsStocksElements();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	prepareNiveauxForSelect() {
		if (this.niveauxHierarchique?.length) {
			const niveaux2Flat = this.niveauxHierarchique.flatMap((x) => x.items.map((y) => ({ ...y, label: `${x.label} > ${y.label}` })));
			this.niveaux3ForSelect = niveaux2Flat.flatMap((x) => x.items.map((y) => ({ id: y.id, label: `${x.label} > ${y.label}` })));
		}
	}

	async initRapportActivites() {
		this.startLoading();
		try {
			const rapports = await this.RapportsActivitesService.getAllRapportActivites();

			this.formatRapportActivites = rapports.sort((a, b) => {
				const labelA = a.label.toUpperCase();
				const labelB = b.label.toUpperCase();

				if (labelA < labelB) return -1;
				if (labelA > labelB) return 1;
				return 0;
			});
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async addRapport() {
		this.openAddRapportModal();
	}

	async updateRapport(id) {
		this.openAddRapportModal(id);
	}

	async duplicateRapport(id) {
		this.openDupliqueRapportModal(id);
	}

	openAddRapportModal(id = null) {
		const _this = this;
		const modalInstance = this.$uibModal.open({
			animation: true,
			size: 'md',
			backdrop: false,
			windowClass: 'modern-modal',
			template: `                
                <div class="modal-header modal-info mas-column mas-p-10" style="gap: 5px">
                    <div class="mas-col-fit">
                        <button type="button" class="close" aria-label="Close" ng-click="$ctrl.close()">
                            <span style="color: white" aria-hidden="true">&times;</span>
                        </button>
                        <h4  ng-show="$ctrl.id === null"  class="modal-title"><span translate="GESTION_RAPPORTS_ACTIVITES.ADD_NEW_FORMAT"></span></h4>
                        <h4  ng-show="$ctrl.id !== null"  class="modal-title"><span translate="GESTION_RAPPORTS_ACTIVITES.UPDATE_FORMAT"></span></h4>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="mas-col-fill">
                        <form name="form" novalidate>
                            <div class="mas-row">
                                <div class="mas-col-12 mas-mb-20">
                                    <div class="form-group">
                                        <label class="col-xs-fit control-label">
                                            <span
                                                class="field-label mandatory-field"
                                                for="rapportLabel"
                                                translate="GESTION_RAPPORTS_ACTIVITES.RAPPORT_LIBELLE"
                                            ></span>
                                        </label>
                                        <div class="col-xs-fil display-validation">
                                            <input
                                                class="form-control"
                                                id="rapportLabel"
                                                name="rapportLabel"
                                                ng-model="$ctrl.rapport.label"                           
                                                maxlength="100"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="mas-col-12">
                                    <span translate="GESTION_RAPPORTS_ACTIVITES.ADD_NEW_FORMAT_INFOS"></span>
                                    <massia-form form="true" label-class="field-label" label="GESTION_RAPPORTS_ACTIVITES.NIVEAUX3">
                                        <select
                                        class="form-control"
                                        id="niveau"
                                        name="niveau"
                                        ng-options="niveau.id.elementId as niveau.label for niveau in $ctrl.niveaux3ForSelect"
                                        ng-model="$ctrl.rapport.codeNiveau3"
                                        ng-change="$ctrl.handleChangeNiveau3()"
                                        ></select>
                                    </massia-form>
                                </div>
                                <span 
                                class="alert alert-danger mas-mt-5 mas-mb-5"
                                ng-show="$ctrl.alertDeleteProduit" translate="GESTION_RAPPORTS_ACTIVITES.ALERT_DELETE_PRODUCT"></span>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="mas-col-fit">
                        <div class="mas-row mas-jc-fend">
                            <div class="mas-col-fit">
                                <button class="btn btn-primary" type="button" ng-disabled="!$ctrl.isFormValid($ctrl.rapport)" ng-click="$ctrl.validate($ctrl.rapport)">
                                    <span ng-hide="$ctrl.isEdit" translate="GESTION_RAPPORTS_ACTIVITES.ADD"></span>
                                    <span ng-show="$ctrl.isEdit" translate="GESTION_RAPPORTS_ACTIVITES.SAVE"></span>
                                </button>
                                <button class="btn btn-primary" type="button" ng-click="$ctrl.close()">
                                    <span class="massia-icon-door_exit"></span>
                                    <span class="hidden-xs" translate="FERMER"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>`,
			controllerAs: '$ctrl',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					this.id = id;

					this.niveaux3ForSelect = _this.niveaux3ForSelect;
					const maxId = Math.max(..._this.formatRapportActivites.map((x) => x.id));
					this.rapport = {
						id: maxId + 1,
						label: '',
						codeNiveau3: _this.niveaux3ForSelect[0].id.elementId,
						isEnabled: true,
						secteurs: []
					};
					this.isEdit = false;
					if (id) {
						this.rapport = angular.copy(_this.formatRapportActivites.find((x) => x.id === id));
						this.isEdit = true;
					}
					this.alertDeleteProduit = false;
					this.handleChangeNiveau3 = () => {
						if (this.rapport.secteurs.length === 0) return;
						this.alertDeleteProduit = true;
					};

					this.isFormValid = ({ label, codeNiveau3 }) => Boolean(label) && Boolean(codeNiveau3);

					this.validate = (rapport) => {
						$uibModalInstance.close(rapport);
					};
					this.close = () => $uibModalInstance.dismiss('cancel');
				}
			]
		});
		modalInstance.result.then(function (result) {
			result.isChanged = true;
			//if exist update
			const index = _this.formatRapportActivites.findIndex((x) => x.id === result.id);
			if (index !== -1) {
				_this.formatRapportActivites[index] = result;
				_this.sauvegarder();
				return;
			}
			_this.formatRapportActivites.push(result);
			_this.sauvegarder();
		});
	}

	getNiveauFormat(elementId) {
		return this.niveaux3ForSelect.find((x) => x.id.elementId === elementId)?.label;
	}

	handleRowSelection(row) {
		this.selectedRapportRow = row;

		this.selectedRapportRow.secteurs.forEach((item) => {
			item.selected = false;
		});
	}

	async addSecteur() {
		this.openAddSecteurModal();
	}
	async updateSecteur(secteurOrder) {
		await this.openAddSecteurModal(secteurOrder);
	}

	deleteSecteur(secteur) {
		if (secteur.produits.length === 0) {
			const index = this.selectedRapportRow.secteurs.findIndex((x) => x.order === secteur.order);
			this.selectedRapportRow.secteurs.splice(index, 1);

			this.selectedRapportRow.secteurs.forEach((secteur, index) => {
				secteur.order = index + 1;
			});
			this.selectedRapportRow.isChanged = true;
			const selectedRapportIndex = this.formatRapportActivites.findIndex((x) => x.id === this.selectedRapportRow.id);
			this.formatRapportActivites[selectedRapportIndex] = this.selectedRapportRow;
		} else {
			this.notification.error('GESTION_RAPPORTS_ACTIVITES.CANT_DELETE_SECTOR_PRODUIT_LIE');
		}
	}

	async openAddSecteurModal(secteurOrder = null) {
		const modalInstance = this.ModalService.open({
			component: 'modalSecteur',
			animation: true,
			size: 'l',
			backdrop: false,
			resolve: {
				selectedRapportRow: () => angular.copy(this.selectedRapportRow),
				secteurOrder: () => secteurOrder,
				isEdit: () => !!secteurOrder
			},
			windowClass: 'modern-modal'
		});
		try {
			const result = await modalInstance.result;
			const index = this.selectedRapportRow.secteurs.findIndex((x) => x.order === result.order);
			if (index !== -1) {
				this.selectedRapportRow.secteurs[index] = result;
			} else {
				this.selectedRapportRow.secteurs.push(result);
			}
			this.selectedRapportRow.isChanged = true;

			const selectedRapportIndex = this.formatRapportActivites.findIndex((x) => x.id === this.selectedRapportRow.id);
			this.formatRapportActivites[selectedRapportIndex] = this.selectedRapportRow;
		} catch (error) {
			console.error('🔥: RapportsActivitesController -> openAddSecteurModal -> error', error);
		}
	}

	async sauvegarder() {
		if (this.isChangedRapportList()) {
			this.startLoading();
			try {
				const rapportsChangedToUpdate = this.formatRapportActivites.filter((rapport) => rapport.isChanged);
				if (rapportsChangedToUpdate.length === 0) {
					this.notification.error('GESTION_RAPPORTS_ACTIVITES.NO_PRODUCT_CHANGED');
					return false;
				}
				await this.RapportsActivitesService.saveRapportsActivites(rapportsChangedToUpdate);
				this.notification.success('GESTION_RAPPORTS_ACTIVITES.SUCCESS_SAVE');
				this.initRapportActivites();
			} catch (ex) {
				this.notification.error(ex.data);
				return false;
			} finally {
				this.stopLoading();
			}
		}
	}

	isChangedRapportList() {
		return this.formatRapportActivites.some((x) => x.isChanged);
	}

	handleDrop(targetIndex, itemSelected) {
		const selectedIndex = this.selectedRapportRow.secteurs.findIndex((x) => x.order === itemSelected.order);
		const action = targetIndex > selectedIndex ? 'up' : 'down';

		this.selectedRapportRow.secteurs.splice(selectedIndex, 1);
		if (action === 'up') {
			this.selectedRapportRow.secteurs.splice(targetIndex - 1, 0, itemSelected);
		} else if (action === 'down') {
			this.selectedRapportRow.secteurs.splice(targetIndex, 0, itemSelected);
		}
		this.handleChange(
			null,
			this.formatRapportActivites.find((x) => x.id === this.selectedRapportRow.id)
		);
		this.selectedRapportRow.secteurs.forEach((secteur, index) => {
			secteur.order = index + 1;
		});
	}

	handleSelectedSecteur(secteur) {
		secteur.selected = true;
		return secteur;
	}

	handleChange($event, rapport) {
		rapport.isChanged = true;
	}

	organiserProduits(rapport) {
		this.$state.go('rapports-activites.rapports-organisation-produits', { idRapport: rapport.id, rapportLabel: rapport.label });
	}

	openDupliqueRapportModal(id) {
		const _this = this;
		const modalInstance = this.$uibModal.open({
			animation: true,
			size: 'md',
			backdrop: false,
			windowClass: 'modern-modal',
			template: `                
                <div class="modal-header modal-info mas-column mas-p-10" style="gap: 5px">
                    <div class="mas-col-fit">
                        <button type="button" class="close" aria-label="Close" ng-click="$ctrl.close()">
                            <span style="color: white" aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title"><span translate="GESTION_RAPPORTS_ACTIVITES.DUPLIQUE_RAPPORT"></span></h4>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="mas-col-fill">
                        <form name="form" novalidate>
                            <div class="mas-row">
                                <div class="mas-col-12 mas-mb-20">
                                    <div class="form-group">
                                        <label class="col-xs-fit control-label">
                                            <span
                                                class="field-label mandatory-field"
                                                for="rapportLabel"
                                                translate="GESTION_RAPPORTS_ACTIVITES.RAPPORT_LIBELLE"
                                            ></span>
                                        </label>
                                        <div class="col-xs-fil display-validation">
                                            <input
                                                class="form-control"
                                                id="rapportLabel"
                                                name="rapportLabel"
                                                ng-model="$ctrl.rapport.label"                           
                                                maxlength="100"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="mas-col-fit">
                        <div class="mas-row mas-jc-fend">
                            <div class="mas-col-fit">
                                <button class="btn btn-primary" type="button" ng-disabled="!$ctrl.isFormValid($ctrl.rapport)" ng-click="$ctrl.validate($ctrl.rapport)">
                                    <span ng-hide="$ctrl.isEdit" translate="GESTION_RAPPORTS_ACTIVITES.ADD"></span>
                                    <span ng-show="$ctrl.isEdit" translate="GESTION_RAPPORTS_ACTIVITES.SAVE"></span>
                                </button>
                                <button class="btn btn-primary" type="button" ng-click="$ctrl.close()">
                                    <span class="massia-icon-door_exit"></span>
                                    <span class="hidden-xs" translate="FERMER"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>`,
			controllerAs: '$ctrl',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					const maxId = Math.max(..._this.formatRapportActivites.map((x) => x.id));
					const rapportToDuplique = angular.copy(_this.formatRapportActivites.find((x) => x.id === id));
					this.rapport = {
						...rapportToDuplique,
						id: maxId + 1,
						label: '',
						isEnabled: true
					};
					this.isFormValid = ({ label, codeNiveau3 }) => Boolean(label) && Boolean(codeNiveau3);

					this.validate = (rapport) => {
						$uibModalInstance.close(rapport);
					};
					this.close = () => $uibModalInstance.dismiss('cancel');
				}
			]
		});
		modalInstance.result.then(function (result) {
			result.isChanged = true;
			_this.formatRapportActivites.push(result);
			_this.saveDuplicateRapport(id, result);
		});
	}

	async saveDuplicateRapport(idRapport, result) {
		this.startLoading();
		try {
			await this.RapportsActivitesService.duplicateRapportActivites(idRapport, result);
			this.notification.success('GESTION_RAPPORTS_ACTIVITES.SUCCESS_DUPLICATE');
			this.initRapportActivites();
		} catch (ex) {
			this.notification.error(ex.data);
			return false;
		} finally {
			this.stopLoading();
		}
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
	// debug = () => {
	//     console.log('🔥: ModalSecteurController -> debug -> this.secteur', this.secteur);
	// };

	canOrganiseProduits(secteurs) {
		return secteurs.length === 0 || !secteurs.some((x) => x.id > 0);
	}
}
